import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataType } from '@vendasta/automata';
import { AutomationVariableMenuService } from '../../../common/components/automation-variable-menu/automation-variable-menu.service';
import { VariableMenuComponent } from '../variable-menu.component';

@Component({
  selector: 'automata-automation-variable-menu',
  templateUrl: './automation-variable-menu.component.html',
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  imports: [VariableMenuComponent, CommonModule],
})
export class AutomationVariableMenuComponent {
  @Output() variableSelected: EventEmitter<string> = new EventEmitter<string>();
  // Data types that are supported by where this component is being used.
  @Input() supportedDataTypes: DataType[];
  @Input() includeRepeatedParams = false;

  // the galaxy form fields have different styling than the mat fields with the galaxy wrapper. This fixes the position
  // of the `| {}` for the new galaxy form fields, once this is used for all inputs it can be removed and
  // forced in the app-variable-menu component
  @Input() useGalaxyCompat = false;
  // By default, the variable menu item selector provides all the things that templates can render, but in order to actually
  // support that, your task that is using this input must render with the templates µs. By not including the default categories
  // the options will only be the data from previous steps which is replaced by the automation workflow engine, not templates µs
  @Input() dontIncludeDefaultCategories = false;

  constructor(public readonly automationVariableMenuService: AutomationVariableMenuService) {}

  variableSelectedEvent(event: any): void {
    this.variableSelected.emit(event);
  }
}
